export default class QUATSError {
  /**
   * @desc Constructor to Initialize to Custom Message in System
   * Normally, if the error is from Axios and from QUATS backend,
   * the message is override based on response code from System backend
   * If the error is unknown, then it will just say it's unknown with the given message.
   * This is also handling network error (no internet connection)
   * @param i18n
   * @param error
   */
  constructor(i18n, error) {
    this.$i18n = i18n
    this.$error = error
    this.message = ''
    if (!this.$error) {
      this.message =  this.$i18n.t('common.unknown_error')
      return
    }

    if (this.$error.isAxiosError) {
      // this is an axios error calendarType
      if (!this.$error.response) {
        this.message = this.$i18n.t('common.network_not_reach_error')
      } else {
        const code = this.$error.response.status
        const message = this.$error.response.data ? this.$error.response.data.message : ''

        if(code === 500) {
          if(!message) {
            this.message = this.$i18n.t('common.network_backend_error')
          } else if(message.includes('E11000')) {
            this.message = this.$i18n.t('common.network_backend_duplicate_error')
          } else {
            this.message = this.$i18n.t('common.network_generic_error', {msg: message})
          }
        } else if (code === 409) {
          this.message = this.$i18n.t('common.network_backend_duplicate_error')
        } else if (code === 404) {
          this.message = this.$i18n.t('common.network_not_found_error')
        } else if (code === 403) {
          this.message = this.$i18n.t('common.network_not_allow')
        } else if (code === 422) {
          const errors = this.$error.response.data.errors
          if(!errors) {
            this.message = message
          } else {
            let msg = ''
            for(const errorKey in errors) {
              msg = msg.concat(errors[errorKey], ' ')
            }
            this.message = msg
          }
        } else if (code  === 401) {
          this.message = this.$i18n.t('common.auth_error', {msg: this.$error.response.data.message})
        } else {
          this.message = message
        }
      }
    } else {
      this.message = error.message
    }
  }
}
